import {raf} from "./util";

export function registerHeader() {
    raf(() => {
        const header = document.querySelector("header#top");

        if (header === null)
            return;

        const threshold = 115;

        let previousTop = 0;

        function onScroll() {
            let doAddCollapsedClass = false;
            let top = "scrollingElement" in document ? document.scrollingElement.scrollTop : document.documentElement.scrollTop;

            if (top < threshold) {
            } else if (top > previousTop) {
                doAddCollapsedClass = true;
            } else {
                doAddCollapsedClass = true;
            }

            if (doAddCollapsedClass)
                header.classList.add("is-collapsed");
            else
                header.classList.remove("is-collapsed");

            previousTop = top;
        }

        window.addEventListener("scroll", onScroll, {passive: true});
        onScroll();
    });
}
